module.exports = __webpack_public_path__ + "img/ATG.e1a1484a.svg";